//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpResponseBase } from '@angular/common/http';

export const AI_AGENT_ADMIN_API_BASE_URL = new InjectionToken<string>('AI_AGENT_ADMIN_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AiConversationsClient {
    protected http: HttpClient;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
	@Inject(HttpClient) http: HttpClient,
	@Optional() @Inject(AI_AGENT_ADMIN_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getList(userId: string | null, status: AiConversationStatus | null, agentType: AiConversationAgentType | null, query: string | null, createdFrom: Date | null, createdTo: Date | null, onlyNegativeFeedback: boolean | null, page: number | null, pageSize: number | null): Observable<AiConversationListPageDto> {
        let url_ = this.baseUrl + "/admin-ai-agent/conversations?";
        if (userId === undefined)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        else if(userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (status === undefined)
            throw new globalThis.Error("The parameter 'status' must be defined.");
        else if(status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (agentType === undefined)
            throw new globalThis.Error("The parameter 'agentType' must be defined.");
        else if(agentType !== null)
            url_ += "AgentType=" + encodeURIComponent("" + agentType) + "&";
        if (query === undefined)
            throw new globalThis.Error("The parameter 'query' must be defined.");
        else if(query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (createdFrom === undefined)
            throw new globalThis.Error("The parameter 'createdFrom' must be defined.");
        else if(createdFrom !== null)
            url_ += "CreatedFrom=" + encodeURIComponent(createdFrom ? "" + createdFrom.toISOString() : "") + "&";
        if (createdTo === undefined)
            throw new globalThis.Error("The parameter 'createdTo' must be defined.");
        else if(createdTo !== null)
            url_ += "CreatedTo=" + encodeURIComponent(createdTo ? "" + createdTo.toISOString() : "") + "&";
        if (onlyNegativeFeedback === undefined)
            throw new globalThis.Error("The parameter 'onlyNegativeFeedback' must be defined.");
        else if(onlyNegativeFeedback !== null)
            url_ += "OnlyNegativeFeedback=" + encodeURIComponent("" + onlyNegativeFeedback) + "&";
        if (page === undefined)
            throw new globalThis.Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined)
            throw new globalThis.Error("The parameter 'pageSize' must be defined.");
        else if(pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiConversationListPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiConversationListPageDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<AiConversationListPageDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiConversationListPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AiConversationsClient.GetList');
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<AiConversationDetailDto> {
        let url_ = this.baseUrl + "/admin-ai-agent/conversations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiConversationDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiConversationDetailDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AiConversationDetailDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiConversationDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AiConversationsClient.GetById');
            }));
        }
        return _observableOf(null as any);
    }
}

export class AiConversationListPageDto implements IAiConversationListPageDto {
    items!: AiConversationListItemDto[];
    pageNumber!: number;
    pageSize!: number;
    pageCount!: number;
    totalItemCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IAiConversationListPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AiConversationListItemDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.pageCount = _data["pageCount"];
            this.totalItemCount = _data["totalItemCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): AiConversationListPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiConversationListPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["pageCount"] = this.pageCount;
        data["totalItemCount"] = this.totalItemCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IAiConversationListPageDto {
    items: AiConversationListItemDto[];
    pageNumber: number;
    pageSize: number;
    pageCount: number;
    totalItemCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class AiConversationListItemDto implements IAiConversationListItemDto {
    id!: string;
    userId!: string;
    agentType!: AiConversationAgentType;
    status!: AiConversationStatus;
    messageCount!: number;
    negativeFeedbackCount!: number;
    createdAt!: Date;
    updatedAt!: Date;

    constructor(data?: IAiConversationListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.agentType = _data["agentType"];
            this.status = _data["status"];
            this.messageCount = _data["messageCount"];
            this.negativeFeedbackCount = _data["negativeFeedbackCount"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AiConversationListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiConversationListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["agentType"] = this.agentType;
        data["status"] = this.status;
        data["messageCount"] = this.messageCount;
        data["negativeFeedbackCount"] = this.negativeFeedbackCount;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAiConversationListItemDto {
    id: string;
    userId: string;
    agentType: AiConversationAgentType;
    status: AiConversationStatus;
    messageCount: number;
    negativeFeedbackCount: number;
    createdAt: Date;
    updatedAt: Date;
}

export enum AiConversationAgentType {
    Undefined = 0,
    Admin = 1,
    Customer = 2,
    PublicSearch = 3,
}

export enum AiConversationStatus {
    Undefined = 0,
    Active = 1,
    Cleared = 2,
    Escalated = 3,
}

export class AiConversationDetailDto implements IAiConversationDetailDto {
    id!: string;
    userId!: string;
    agentType!: AiConversationAgentType;
    status!: AiConversationStatus;
    createdAt!: Date;
    updatedAt!: Date;
    escalation!: AiConversationEscalationDto | undefined;
    messages!: AiConversationMessageDto[];

    constructor(data?: IAiConversationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.agentType = _data["agentType"];
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.escalation = _data["escalation"] ? AiConversationEscalationDto.fromJS(_data["escalation"]) : undefined as any;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(AiConversationMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AiConversationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiConversationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["agentType"] = this.agentType;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["escalation"] = this.escalation ? this.escalation.toJSON() : undefined as any;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAiConversationDetailDto {
    id: string;
    userId: string;
    agentType: AiConversationAgentType;
    status: AiConversationStatus;
    createdAt: Date;
    updatedAt: Date;
    escalation: AiConversationEscalationDto | undefined;
    messages: AiConversationMessageDto[];
}

export class AiConversationEscalationDto implements IAiConversationEscalationDto {
    reason!: string | undefined;
    summary!: string | undefined;

    constructor(data?: IAiConversationEscalationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): AiConversationEscalationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiConversationEscalationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["summary"] = this.summary;
        return data;
    }
}

export interface IAiConversationEscalationDto {
    reason: string | undefined;
    summary: string | undefined;
}

export class AiConversationMessageDto implements IAiConversationMessageDto {
    sequence!: number;
    role!: AiConversationMessageRole;
    content!: string;
    feedback!: AiConversationMessageFeedback | undefined;
    toolCalls!: AiConversationToolCallDto[] | undefined;
    toolResults!: AiConversationToolResultDto[] | undefined;
    knowledgeCards!: AiConversationKnowledgeCardDto[] | undefined;
    createdAt!: Date;

    constructor(data?: IAiConversationMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequence = _data["sequence"];
            this.role = _data["role"];
            this.content = _data["content"];
            this.feedback = _data["feedback"];
            if (Array.isArray(_data["toolCalls"])) {
                this.toolCalls = [] as any;
                for (let item of _data["toolCalls"])
                    this.toolCalls!.push(AiConversationToolCallDto.fromJS(item));
            }
            if (Array.isArray(_data["toolResults"])) {
                this.toolResults = [] as any;
                for (let item of _data["toolResults"])
                    this.toolResults!.push(AiConversationToolResultDto.fromJS(item));
            }
            if (Array.isArray(_data["knowledgeCards"])) {
                this.knowledgeCards = [] as any;
                for (let item of _data["knowledgeCards"])
                    this.knowledgeCards!.push(AiConversationKnowledgeCardDto.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AiConversationMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiConversationMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequence"] = this.sequence;
        data["role"] = this.role;
        data["content"] = this.content;
        data["feedback"] = this.feedback;
        if (Array.isArray(this.toolCalls)) {
            data["toolCalls"] = [];
            for (let item of this.toolCalls)
                data["toolCalls"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.toolResults)) {
            data["toolResults"] = [];
            for (let item of this.toolResults)
                data["toolResults"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.knowledgeCards)) {
            data["knowledgeCards"] = [];
            for (let item of this.knowledgeCards)
                data["knowledgeCards"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAiConversationMessageDto {
    sequence: number;
    role: AiConversationMessageRole;
    content: string;
    feedback: AiConversationMessageFeedback | undefined;
    toolCalls: AiConversationToolCallDto[] | undefined;
    toolResults: AiConversationToolResultDto[] | undefined;
    knowledgeCards: AiConversationKnowledgeCardDto[] | undefined;
    createdAt: Date;
}

export enum AiConversationMessageRole {
    Undefined = 0,
    User = 1,
    Assistant = 2,
    Tool = 3,
    System = 4,
}

export enum AiConversationMessageFeedback {
    Undefined = 0,
    Useful = 1,
    NotUseful = 2,
}

export class AiConversationToolCallDto implements IAiConversationToolCallDto {
    id!: string;
    pluginName!: string;
    functionName!: string;
    arguments!: string | undefined;

    constructor(data?: IAiConversationToolCallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pluginName = _data["pluginName"];
            this.functionName = _data["functionName"];
            this.arguments = _data["arguments"];
        }
    }

    static fromJS(data: any): AiConversationToolCallDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiConversationToolCallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pluginName"] = this.pluginName;
        data["functionName"] = this.functionName;
        data["arguments"] = this.arguments;
        return data;
    }
}

export interface IAiConversationToolCallDto {
    id: string;
    pluginName: string;
    functionName: string;
    arguments: string | undefined;
}

export class AiConversationToolResultDto implements IAiConversationToolResultDto {
    id!: string;
    pluginName!: string;
    functionName!: string;
    result!: string | undefined;

    constructor(data?: IAiConversationToolResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pluginName = _data["pluginName"];
            this.functionName = _data["functionName"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): AiConversationToolResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiConversationToolResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pluginName"] = this.pluginName;
        data["functionName"] = this.functionName;
        data["result"] = this.result;
        return data;
    }
}

export interface IAiConversationToolResultDto {
    id: string;
    pluginName: string;
    functionName: string;
    result: string | undefined;
}

export class AiConversationKnowledgeCardDto implements IAiConversationKnowledgeCardDto {
    id!: string;
    intent!: string | undefined;
    problem!: string | undefined;
    score!: number | undefined;

    constructor(data?: IAiConversationKnowledgeCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.intent = _data["intent"];
            this.problem = _data["problem"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): AiConversationKnowledgeCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiConversationKnowledgeCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["intent"] = this.intent;
        data["problem"] = this.problem;
        data["score"] = this.score;
        return data;
    }
}

export interface IAiConversationKnowledgeCardDto {
    id: string;
    intent: string | undefined;
    problem: string | undefined;
    score: number | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;
    operationName: string;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any, operationName?: string) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
        this.operationName = operationName ?? '';
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any, operationName?: string): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null, operationName));
}

function anyToText(data: unknown): Observable<string>{
    if (data instanceof Blob) return blobToText(data);
    return new Observable<string>(observer => {
        if (!data) {
            observer.next("");
            observer.complete();
            return;
        }
        observer.next(JSON.stringify(data));
        observer.complete();
    });
}

function blobToText(blob: Blob): Observable<string> {
    return new Observable<string>(observer => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            try {
                blob.text().then((blobText: string) => {
                    observer.next(blobText);
                    observer.complete();
                }, err => observer.error(err));
            }
            catch { observer.error(); }
        }
    });
}